import SpecialAccessPage from './SpecialAccessPage';
export default SpecialAccessPage;